import { getPlatform } from 'lib/tools/getPlatform.js'
import Bridge from 'lib/lib/Bridge.js'
import getMP from 'utils/getMP.js'
import { GetQueryString } from 'lib/tools/utils'

/**
 * 用于复制文本
 * @param {String} str 需要被复制的文本
 */
export const copyText = str => {
  let selection = window.getSelection()
  let range = document.createRange()
  let $code = document.createElement('div')
  $code.display = 'none'
  $code.innerHTML = str
  document.body.appendChild($code)

  range.selectNodeContents($code)
  selection.removeAllRanges()
  selection.addRange(range)

  document.execCommand('copy')
  selection = null
  range = null
  document.body.removeChild($code)
}

/**
 * 保留N位小数,不够补0
 * @param {Number} num
 * @param {Number} zeroCount
 */
export const toFixed = (num, zeroCount = 2) => {
  let result = parseFloat(num)
  if (isNaN(result)) {
    throw new Error('传递参数错误，请检查！')
  }
  result = Math.round(num * 100) / 100
  let s_x = result.toString()
  let pos_decimal = s_x.indexOf('.')
  if (pos_decimal < 0) {
    pos_decimal = s_x.length
    s_x += '.'
  }
  while (s_x.length <= pos_decimal + zeroCount) {
    s_x += '0'
  }
  return s_x
}

/**
 * 数字超过1000自动换算成k并且保留一位小数
 * @param {Number}
 **/
export const unitConversion = number => {
  let num = Number(number)

  if (num >= 1000) {
    num = num / 1000

    return num.toFixed(1) + 'k'
  } else {
    return num
  }
}

export const updateQueryStringParameter = (url, key, value) => {
  if (!value) {
    return url
  }
  const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
  const separator = url.indexOf('?') !== -1 ? '&' : '?'
  if (url.match(re)) {
    return url.replace(re, '$1' + key + '=' + value + '$2')
  } else {
    return url + separator + key + '=' + value
  }
}

/**
 * 转千位符
 * @param {Number}
 **/
export const unitThousand = number => {
  var reg = /\d{1,3}(?=(\d{3})+$)/g
  return (number + '').replace(reg, '$&,')
}

export function isObject(val) {
  return Object.prototype.toString.call(val) === '[object Object]'
}

/**
 * 秒数转成 '00:12:32' 的格式
 * @param {second}
 */
export const secondToTimeStr = t => {
  if (t !== 0 && !t) {
    return '00:00'
  }

  t = Number(t)
  let h = '00'
  let m = '00'
  let s = '00'
  if (t < 60) {
    s = t < 10 ? `0${t}` : t
  } else if (t < 3600) {
    m = parseInt(t / 60) < 10 ? `0${parseInt(t / 60)}` : parseInt(t / 60)
    s = t % 60 < 10 ? `0${t % 60}` : t % 60
  } else if (t >= 3600) {
    const eH = parseInt(t / 3600)
    const eM = parseInt((t % 3600) / 60)
    const eS = t % 60
    h = eH < 10 ? `0${eH}` : eH
    m = eM < 10 ? `0${eM}` : eM
    s = eS < 10 ? `0${eS}` : eS
    return `${h}:${m}:${s}`
  }
  return `${m}:${s}`
}

// 图片预加载
export const preloadImage = function (src) {
  return new Promise((resolve, reject) => {
    let img = new Image()
    img.onload = () => {
      resolve()
    }
    img.onerror = () => {
      reject()
    }
    img.src = src
  })
}

// 在vue组件中调用，传入this
export const commonGetToken = async function (ctx) {
  if (ctx.$platform.isYixinliApp) {
    const { token } = await ctx.$bridge.getToken()
    return token
  } else {
    const { token } = await ctx.$store.dispatch('getUserInfo')
    return token
  }
}

export const whichTransitionEvent = function () {
  let t,
    el = document.createElement('surface'),
    transitions = {
      transition: 'transitionend',
      OTransition: 'oTransitionEnd',
      MozTransition: 'transitionend',
      WebkitTransition: 'webkitTransitionEnd'
    }

  for (t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t]
    }
  }
}

// 后端返回url，前端需判断url是否客户端协议。
// 调用时需绑定上下文，例如：jumpUrlFromAfterEnd.call(this, url)
export const jumpUrlFromAfterEnd = function (url) {
  if (url) {
    if (url.indexOf('yixinli://') > -1) {
      window.location.href = url
    } else {
      this.routerPush(url)
    }
  } else {
    this.$toast({
      text: '跳转url不存在！',
      zIndexTop: true
    })
  }
}

export const isDef = function (val) {
  return val !== undefined && val !== null
}

export const isUnDef = function (val) {
  return val === undefined || val === null
}

export const getStatusBarHeight = function (callbackName = 'commonHasTouch') {
  return new Promise((resolve, reject) => {
    try {
      const bridge = new Bridge({
        methods: [
          {
            method: callbackName,
            callback: obj => {
              const platform = getPlatform()
              const { hasNotch, notchHeight } = obj
              const statusBarHeight =
                notchHeight && window.devicePixelRatio
                  ? (notchHeight / window.devicePixelRatio) | 0
                  : hasNotch === 1 || hasNotch === true
                  ? platform.isAndroid
                    ? 35
                    : 40
                  : 20
              resolve(statusBarHeight)
            }
          }
        ]
      })

      bridge.call('hasNotch', {
        callbackName
      })
    } catch (e) {
      reject(e)
    }
  })
}

/**
 * 先将oss参数移除，然后再加我们自己的oss参数
 *
 * example:
 * url = https://ossimg.xinli001.com/xxx.jpg!80?x-oss-process=image/quality,q_80
 * addOssParams(url, 255) => https://ossimg.xinli001.com/xxx.jpg?x-oss-process=image/resize,w_255
 */
export const addOssParamsForcibly = function (url, w, h) {
  if (!url) return url
  if (!w && !h) {
    return url
  }
  return (
    url.split(/(!\d+)?\?/)[0] +
    `?x-oss-process=image/resize` +
    (w ? `,w_${w}` : '') +
    (h ? `,h_${h}` : '')
  )
}

export const simpleDeepClone = function (val) {
  if (isObject(val) || Array.isArray(val)) {
    return JSON.parse(JSON.stringify(val))
  } else {
    return val
  }
}

/**
 * 判断页面是否运行在微信小程序webview
 */
export const inMiniProgramWebview = function () {
  const isServer = typeof window === 'undefined'
  if (isServer) return false
  const isMp = getMP()
  return isMp && GetQueryString('isWebviewMp')
}
